import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentPinGhostCommentIndicator from './VeltCommentPinGhostCommentIndicator/VeltCommentPinGhostCommentIndicator';
import VeltCommentPinIndex from './VeltCommentPinIndex/VeltCommentPinIndex';
import VeltCommentPinTriangle from './VeltCommentPinTriangle/VeltCommentPinTriangle';
import VeltCommentPinUnreadCommentIndicator from './VeltCommentPinUnreadCommentIndicator/VeltCommentPinUnreadCommentIndicator';
import VeltCommentPinPrivateCommentIndicator from './VeltCommentPinPrivateCommentIndicator/VeltCommentPinPrivateCommentIndicator';
import VeltCommentPinNumber from './VeltCommentPinNumber/VeltCommentPinIndex';
var VeltCommentPinWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-wireframe", __assign({}, transformedProps), children));
};
VeltCommentPinWireframe.GhostCommentIndicator = VeltCommentPinGhostCommentIndicator;
VeltCommentPinWireframe.Index = VeltCommentPinIndex;
VeltCommentPinWireframe.PrivateCommentIndicator = VeltCommentPinPrivateCommentIndicator;
VeltCommentPinWireframe.Triangle = VeltCommentPinTriangle;
VeltCommentPinWireframe.UnreadCommentIndicator = VeltCommentPinUnreadCommentIndicator;
VeltCommentPinWireframe.Number = VeltCommentPinNumber;
export default VeltCommentPinWireframe;
